import { Route } from '@angular/router';
import {
  AdminLoginPage,
  authGuard,
  ChangePasswordPage,
  fromLoginOnlyGuard,
  loginRedirectGuard,
  PasswordResetConfirmationForm,
  PasswordResetForm,
  PasswordResetPage,
  roleGuard,
  termsGuard,
} from '@aurrica-web/auth';
import { UserTypeEnum } from '@aurrica-web/core-data';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@aurrica-web/freight').then((m) => m.bookingRoutes),
    canActivate: [authGuard, roleGuard, termsGuard],
    data: {
      roles: [UserTypeEnum.SUPER_ADMIN],
    },
  },
  {
    path: 'login',
    component: AdminLoginPage,
    canActivate: [loginRedirectGuard],
  },
  {
    path: 'change-password',
    component: ChangePasswordPage,
    canActivate: [fromLoginOnlyGuard],
  },
  {
    path: 'password-reset',
    component: PasswordResetPage,
    children: [
      {
        path: '',
        component: PasswordResetForm,
      },
      {
        path: 'confirm',
        component: PasswordResetConfirmationForm,
      },
    ],
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
